import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import MicroModal from 'micromodal';
import { Store } from '@ngxs/store';
import { Configuration, Organization } from 'remarketing-angular-library';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddressChangeFormComponent } from '../address-change-form/address-change-form.component';

import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-address-change-modal',
    templateUrl: './address-change-modal.component.html',
    styleUrls: ['./address-change-modal.component.scss'],
    imports: [TranslocoDirective, AddressChangeFormComponent]
})
export class AddressChangeModalComponent implements OnInit, OnDestroy {
  configuration: Configuration;
  private destroyed$ = new Subject();

  @Output() cancelEditing = new EventEmitter();
  @Output() continueEditing = new EventEmitter();
  @Output() success = new EventEmitter<boolean>();
  @Output() sendError = new EventEmitter<boolean>();
  addressForm: UntypedFormGroup;
  showError = false;

  @Input() modalId = 'address-change-modal';
  @Input() variant: 'title' | 'physical';

  organization: Organization;

  get isTitle() {
    return this.variant === 'title';
  }

  get isPhysical() {
    return this.variant === 'physical';
  }

  constructor(
    private readonly store: Store
  ) {}

  ngOnInit() {
    this.store
      .select(_state => _state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(_configuration => (this.configuration = _configuration));
  }

  closeModal() {
    MicroModal.close(this.modalId);
  }

  receiveError(data) {
    this.showError = data;
    this.sendError.emit(this.showError);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
